<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-3">
      <div class="breadcrumb-title border-0 mb-3 mt-md-0 mt-4">
        <app-list-header
          [title]="'APP_REQUEST.TITLE' | translate"
          icon="bi bi-bag-check"
          [$parent]="getSelf()"
        >
        </app-list-header>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="search-card compact-inputs">
          <div class="card-header search-card-header border-bottom-0">
            <button
              mat-stroked-button
              color="primary"
              class="ms-1"
              (click)="toggleSearch()"
              matTooltip="{{ 'APP_REQUEST.SEARCH.FILTER' | translate }}"
            >
              <mat-icon>tune</mat-icon>
              <span>{{ "APP_REQUEST.SEARCH.Tooltip.FILTER" | translate }}</span>
            </button>
            <button
              mat-stroked-button
              color="warn"
              class="ms-2"
              (click)="restoreColumnOrder()"
              [disabled]="!isColumnOrderChanged()"
              matTooltip="{{ 'APP_REQUEST.SEARCH.Restore' | translate }}"
              aria-label="Restore Table Column Order"
            >
              <mat-icon>restore</mat-icon>
              <span>{{ "APP_REQUEST.SEARCH.RESTORE" | translate }}</span>
            </button>
          </div>

          <div *ngIf="isExpanded" class="pb-0 card-body">
            <div
              class="row align-items-center mt-1 compact-inputs dropdown-pd-none"
            >
              <!-- Application Name -->
              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "APP_REQUEST.SEARCH.APPlication_NAME" | translate
                      }}</mat-label>
                      <input
                        matInput
                        placeholder=""
                        [(ngModel)]="applicationName"
                      />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_REQUEST.SEARCH.Tooltip.APP_Name' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Application Name"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "APP_REQUEST.SEARCH.SUBSCRIBED_BY" | translate
                      }}</mat-label>
                      <input
                        matInput
                        placeholder=""
                        [(ngModel)]="userFirstname"
                      />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_REQUEST.SEARCH.Tooltip.Subscriber' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Subscribed by"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "APP_REQUEST.SEARCH.ACCESS_KEY" | translate
                      }}</mat-label>
                      <input matInput placeholder="" [(ngModel)]="accessKey" />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_REQUEST.SEARCH.Tooltip.Access_Key' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Access Key"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <!-- <mat-label>Status</mat-label> -->

                      <mat-select [(ngModel)]="status">
                        <mat-option value="">{{
                          "APP_REQUEST.SEARCH.STATUS.NO_STATUS" | translate
                        }}</mat-option>
                        <mat-option value="hold">{{
                          "APP_REQUEST.SEARCH.STATUS.HOLD" | translate
                        }}</mat-option>
                        <mat-option value="pending">{{
                          "APP_REQUEST.SEARCH.STATUS.PENDING" | translate
                        }}</mat-option>
                        <mat-option value="approved">{{
                          "APP_REQUEST.SEARCH.STATUS.APPROVED" | translate
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_REQUEST.SEARCH.Tooltip.Status' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Status"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "APP_REQUEST.SEARCH.DATE" | translate
                      }}</mat-label>
                      <input
                        matInput
                        placeholder=""
                        [(ngModel)]="createdDatetime"
                      />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_REQUEST.SEARCH.Tooltip.Search_Date' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Date"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex">
                  <button
                    mat-stroked-button
                    color="primary"
                    class="ms-1 d-flex align-items-center"
                    (click)="requestSearch()"
                  >
                    <mat-icon>search</mat-icon>
                    <span>{{ "APP_REQUEST.SEARCH.Search" | translate }}</span>
                  </button>
                  <button
                    mat-stroked-button
                    color="warn"
                    class="ms-2"
                    (click)="resetFilters()"
                  >
                    <i class="fa fa-eraser eraser-warn-dark"></i>
                    <span class="ms-2">{{
                      "APP_REQUEST.SEARCH.RESET" | translate
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-container">
            <div class="table-responsive table-scrollable">
              <table
                class="table table-bordered table-hover table-sticky-header"
              >
                <thead>
                  <tr
                    cdkDropList
                    cdkDropListOrientation="horizontal"
                    (cdkDropListDropped)="drop($event)"
                    [cdkDropListData]="displayedColumns"
                  >
                    <!-- Dynamic Columns -->
                    <th
                      *ngFor="let col of getCurrentColumns(); let i = index"
                      cdkDrag
                    >
                      <div class="header-content">
                        <span class="drag-handle" cdkDragHandle>⋮⋮</span>

                        <!-- LABEL + SORT -->
                        <span
                          class="header-label"
                          [class.not-sortable]="!col.sortable"
                          (click)="sortTable(col.key)"
                        >
                          {{ col.label | translate }}
                          <!-- SORT ICONS ONLY IF SORTABLE -->
                          <ng-container *ngIf="col.sortable">
                            <i
                              *ngIf="
                                sortedField === col.key && sortOrder === 'ASC'
                              "
                              class="fa fa-sort-up ms-1"
                            ></i>
                            <i
                              *ngIf="
                                sortedField === col.key && sortOrder === 'DESC'
                              "
                              class="fa fa-sort-down ms-1"
                            ></i>
                            <i
                              *ngIf="sortedField !== col.key"
                              class="fa fa-sort ms-1 text-muted"
                            ></i>
                          </ng-container>
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <!-- Table Rows -->
                  <tr *ngFor="let element of form.list; let i = index">
                    <td
                      *ngFor="let col of getCurrentColumns()"
                      [ngClass]="{
                        'text-center':
                          col.key === 'sno' || col.key === 'qrCode',
                        'text-start': col.key === 'action',
                      }"
                    >
                      <ng-container [ngSwitch]="col.key">
                        <!-- S.No Column -->
                        <span *ngSwitchCase="'sno'">
                          {{ pageIndex(i) }}
                        </span>

                        <!-- App Column -->
                        <span *ngSwitchCase="'applicationName'">
                          {{ element.applicationName }}
                        </span>

                        <!-- Subscribed By Column -->
                        <span *ngSwitchCase="'subscribedBy'">
                          <span class="text-muted" style="white-space: nowrap">
                            {{ element.userFirstname }} |
                            {{ element.organizationName }}
                          </span>
                        </span>

                        <!-- Access Key Column -->
                        <span *ngSwitchCase="'accessKey'">
                          <span
                            class="access-key-text"
                            style="white-space: nowrap"
                          >
                            {{ element.accessKey }}
                          </span>
                        </span>

                        <!-- Status Column -->
                        <span *ngSwitchCase="'status'">
                          <div
                            class="status-container compact-inputs dropdown-pd-none"
                          >
                            <mat-form-field
                              appearance="outline"
                              class="w-100"
                              [class.status-approved]="
                                getStatusClass(element.status) ===
                                'status-approved'
                              "
                              [class.status-pending]="
                                getStatusClass(element.status) ===
                                'status-pending'
                              "
                              [class.status-hold]="
                                getStatusClass(element.status) === 'status-hold'
                              "
                              [class.status-rejected]="
                                getStatusClass(element.status) ===
                                'status-rejected'
                              "
                              [class.status-blocked]="
                                getStatusClass(element.status) ===
                                'status-blocked'
                              "
                              [class.status-default]="
                                getStatusClass(element.status) ===
                                'status-default'
                              "
                            >
                              <mat-select
                                [(value)]="element.status"
                                (selectionChange)="
                                  changeStatus(element.id, element.status)
                                "
                                placeholder="Select Status"
                              >
                                <mat-option value="No status">{{
                                  "APP_REQUEST.SEARCH.STATUS.Select" | translate
                                }}</mat-option>
                                <mat-option value="pending">{{
                                  "APP_REQUEST.SEARCH.STATUS.PENDING"
                                    | translate
                                }}</mat-option>
                                <mat-option value="approved">{{
                                  "APP_REQUEST.SEARCH.STATUS.APPROVED"
                                    | translate
                                }}</mat-option>
                                <mat-option value="hold">{{
                                  "APP_REQUEST.SEARCH.STATUS.HOLD" | translate
                                }}</mat-option>
                                <mat-option value="rejected">{{
                                  "APP_REQUEST.SEARCH.STATUS.Rejected"
                                    | translate
                                }}</mat-option>
                                <mat-option value="blocked">{{
                                  "APP_REQUEST.SEARCH.STATUS.BLOCKED"
                                    | translate
                                }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </span>

                        <!-- Date Column -->
                        <span *ngSwitchCase="'createdBy'">
                          {{ element.createdDatetime | date: "fullDate" }}
                        </span>

                        <!-- QR Code Column -->
                        <span *ngSwitchCase="'qrCode'">
                          <div class="qr-code-container">
                            <a
                              *ngIf="hasQRCode(element.qrCode)"
                              [href]="getDoc(element.qrCode)"
                              target="_blank"
                              class="qr-code-link"
                              matTooltip="Click to view QR Code"
                            >
                              <img
                                [src]="getDocThumbnail(element.qrCode)"
                                alt="QR Code"
                                class="qr-code-image"
                                (error)="onImageError($event)"
                                loading="lazy"
                              />
                            </a>
                            <div
                              *ngIf="!hasQRCode(element.qrCode)"
                              class="no-qr-code"
                            >
                              <mat-icon>qr_code_2</mat-icon>
                            </div>
                          </div>
                        </span>

                        <!-- Action Column -->
                        <span *ngSwitchCase="'action'">
                          <div class="d-flex justify-content-center">
                            <button
                              mat-stroked-button
                              color="warn"
                              class="icon-center icon-clean icon-width"
                              (click)="deleteStatus(element.id)"
                              [title]="
                                'appRequest.table.actions.delete' | translate
                              "
                              matTooltip="{{
                                'appRequest.table.actions.delete' | translate
                              }}"
                            >
                              <mat-icon class="icon-compact">delete</mat-icon>
                            </button>
                          </div>
                        </span>
                      </ng-container>
                    </td>
                  </tr>

                  <!-- No Records -->
                  <tr *ngIf="form.list.length === 0">
                    <td
                      [attr.colspan]="getCurrentColumns().length"
                      class="text-center py-4"
                    >
                      <div class="text-muted">
                        <i class="fas fa-inbox fa-2x mb-2"></i>
                        <p>No records found</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>